import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { CalendarDays } from "lucide-react";
import { fmtDate } from "@/lib/format";

export function DatePicker({ value, onChange, testid = "date-picker" }) {
  const selected = value ? new Date(value + "T00:00:00") : undefined;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          data-testid={testid}
          className="w-full justify-start font-normal text-left"
        >
          <CalendarDays className="mr-2 h-4 w-4 text-muted-foreground" />
          {value ? fmtDate(value) : <span className="text-muted-foreground">Choisir une date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-popover" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => {
            if (d) {
              const iso = new Date(d.getTime() - d.getTimezoneOffset() * 60000)
                .toISOString()
                .slice(0, 10);
              onChange(iso);
            }
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
